import { connect } from 'react-redux';

import { MapStateToProps } from '~commonInfra/utils/ConnectUtils';

import { AppState } from '../../bootstrap/redux/state/AppState';
import { AppRoot, AppRootOwnProps, AppRootStateProps } from './AppRoot';

export const mapStateToProps: MapStateToProps<AppRootStateProps> = (state: AppState) => ({
    rootAdminUiState: state.rootAdminUiState
  });

export const AppRootStateConnector: React.ComponentClass<AppRootOwnProps> = connect(mapStateToProps)(AppRoot);